import { TyreActionSelector } from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/TyreReplacementTableRow/components/TyreActions/components";

import type { Appointment, VehicleTyre, VehicleTyreReplacement } from "models";

type TyreActionsProps = {
  vehicleTyre: VehicleTyre;
  replacement: VehicleTyreReplacement;
  appointment: Appointment;
  readOnly?: boolean;
};

export const TyreActions = ({ vehicleTyre, replacement, appointment, readOnly }: TyreActionsProps) => (
  <div className="tyre-action">
    <div className="tyre-container">
      <TyreActionSelector vehicleTyre={vehicleTyre} replacement={replacement} appointment={appointment} readOnly={readOnly} />
    </div>
  </div>
);
